"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewApplication extends new_item_1.default {
    constructor(newApplication) {
        super();
        this.clientName = newApplication.clientName;
        this.allowedGrants = newApplication.allowedGrants;
        this.scopes = newApplication.scopes;
    }
}
exports.default = NewApplication;
//# sourceMappingURL=new-application.js.map